import React from "react";
import { Modal, Button } from "react-bootstrap";
import LoaderInline from "shared/loader/LoaderInline";
//import { RoleType } from "constants/roleType";

const SwitchAccountModal = (props) => {
  //const isOwner = props?.user?.role === RoleType.KITCHEN_OWNER;

  return (
    <Modal
      {...props}
      aria-labelledby="addMenu__item__modal"
      id="confirmation__modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="confirmation__heading">
          {/* {!isOwner ? "Owner Account Required" : "Authorize Integration"} */}
          Owner Account Required
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <p lassName="mb-0">
          You are logged in as <b>{props?.user?.email}</b> ({props?.user?.role}
          ).
        </p>
        {/* {!isOwner ? (
          <p lassName="mb-0">
            This integration requires an <b>owner</b> account.
            <br />
            Please switch to an owner account to continue.
          </p>
        ) : (
          <p lassName="mb-0">
            Would you like to continue as this account, or switch to a different
            owner account?
          </p>
        )} */}
        <p lassName="mb-0">
          This integration requires an <b>owner</b> account.
          <br />
          Please switch to an owner account to continue.
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        {/* {isOwner && (
          <Button onClick={props.onContinue} className="red-btn btn">
            Continue
          </Button>
        )} */}
        <Button
          onClick={props.onCancel}
          className="cancel-btn red-btn-ghost btn"
        >
          Cancel
        </Button>
        <Button
          onClick={props.onSubmit}
          className="red-btn btn"
          disabled={props.onLoading}
        >
          {props.onLoading ? <LoaderInline /> : "Switch Account"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SwitchAccountModal;
